import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { PayGateModalContent } from './content';
export const PayGateModal = observer(_ref => {
  let disableEscapeKeyDown = _ref.disableEscapeKeyDown,
    methodAdded = _ref.methodAdded,
    noCancelletion = _ref.noCancelletion,
    open = _ref.open,
    trigger = _ref.trigger,
    newMethodAdded = _ref.newMethodAdded,
    customTrigger = _ref.customTrigger,
    handleCloseCustom = _ref.handleCloseCustom;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disableEscapeKeyDown: disableEscapeKeyDown,
    handleClose: () => {
      if (handleCloseCustom) handleCloseCustom();
      setIsOpen(false);
    },
    handleOpen: () => setIsOpen(true),
    isOpen: isOpen,
    noCloseButton: noCancelletion,
    title: t('subscriptions.add_payment_information'),
    noFooter: true,
    trigger: customTrigger !== undefined ? customTrigger : trigger ? /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      id: "savePaymentMethod",
      'custom-attribute': '484-pay-gate-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('subscriptions.add_new_payment_method'))) : null
  }, /*#__PURE__*/React.createElement(PayGateModalContent, {
    isOpen: isOpen,
    methodAdded: methodAdded,
    newMethodAdded: newMethodAdded
  }));
});
export default PayGateModal;